/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { FontWeight } from "components/Text";
import { Dialog, DialogBody, DialogIcon, DialogText } from "./styles";
import globalStyles from "globalStyles";

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${globalStyles.components.dialog.dialog_confirm.background};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${globalStyles.components.dialog.dialog_confirm.color};
  cursor: pointer;
`;

export const TextArea2 = styled.textarea`
  width: 100%;
  height: 120px;
  padding: 15px;
  border: 2px solid ${globalStyles.components.dialog.text_area.border};
  border-radius: 8px;
  resize: none;
  font-family: Courier, monospace;
  font-weight: ${FontWeight.SemiBold};
  color: ${globalStyles.components.dialog.text_area.color};
  font-size: 14px;
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${globalStyles.components.dialog.dialog_rejected.background};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${globalStyles.components.dialog.dialog_rejected.color};
  cursor: pointer;
`;

export const ContentTextArea = styled.div`
  width: 100%;
  margin-top: 0px;
  margin-bottom: 0px;
  p {
    color: ${globalStyles.components.dialog.content_text_area};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px;
  }
`;

export const CustomTitle = styled.div`
 width: 100%;
 padding: 22px 13px;
 font-weight: 800;
 font-size: 20px;
 color: ${globalStyles.components.dialog.content_text_area};
  }
`;

export default function DialogComponent(props) {
  const [visible, setVisible] = useState(props.show);
  const myRef = useRef();

  const handleClickOutside = (e) => {
    if (!myRef.current.contains(e.target)) {
      props.setDialog({ visible: false, title: null, icon: null, args: null });
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  useEffect(() => {
    setVisible(props.show);
  }, [props.show]);

  return (
    <Dialog canShow={visible}>
      <DialogBody width={props.size} ref={myRef}>
        {props.customTitle && <CustomTitle>
          {props.title}
        </CustomTitle>}
        {!props.customTitle && <DialogIcon pink={props.icon}>
          {/* <FontAwesomeIcon icon={props.icon}></FontAwesomeIcon> */}
          <DialogText>{props.title}</DialogText>
        </DialogIcon>}
        {props.children}
      </DialogBody>
    </Dialog>
  );
}
